import apiClient from './apiClient';

const userRoleAPI = {
  getAllRoles: () => apiClient.get(`/role/index`),
};

export default userRoleAPI;